export default __webpack_public_path__ + "static/media/CNo.61-6.b59509e8.jpg";